import { Memo } from "../../models/memo";
import { useTranslation } from "react-i18next";
import { decode } from "html-entities";

export function CheckInMemoCell({ memo }: { memo: Memo }) {
  const { t } = useTranslation();

  return (
    <div className={"w-full rounded-md border border-base-300 my-2 p-2"}>
      <div
        className={"badge badge-xs badge-ghost p-2 py-0.5 mb-1"}
      >{`${memo.createdBy} / ${memo.createdAt.format(t("datetime2_format"))}`}</div>
      <div className={"break-all whitespace-pre-line"}>{decode(memo.body)}</div>
    </div>
  );
}
